/*------------------------------------*\
    MODULES
\*------------------------------------*/
import Shepherd from 'shepherd.js';

var site = require('../../site/_data/site');

/*------------------------------------*\
    FEEDBACK TOUR SECTION
\*------------------------------------*/
class FeedbackTourSection {
    constructor(passedElement) {
        let self = this;
        self.elem = passedElement;
    }

    /*-------------------------------------------------*\
        INIT
    \*-------------------------------------------------*/
    init() {
        let self = this;

        var shepherd = new Shepherd.Tour({
          defaultStepOptions: {
            classes: 'tour-section',
            scrollTo: {
              behavior: 'smooth',
              block: 'center'
            }
          },
          steps: [
            {
              title: 'Enter your feedback',
              text: 'Use the form below to enter your feedback. You can come back and update this later if you wish.',
              attachTo: {
                element: window.innerWidth > 400 ? '.js-feedback-tour-section' : null,
                on: 'top'
              },
              buttons: [
                {
                  action: function() {
                    return this.next();
                  },
                  text: 'Close'
                }
              ]
            }
          ],
          useModalOverlay: true
        });

        // If consultation closed don't show
        if(site.consultation.feedback_active == true) {
          // Check if tour popup has already been dismissed
          if(localStorage.getItem('tour-question-seen')) {
            console.log("%c" + 'Tour question seen', "color: green")
          } else {
            localStorage.setItem('tour-question-seen', true);

            shepherd.start();
          }
        }
    }
}

export default FeedbackTourSection;